import AddService from "../../components/AddService/AddService";
import Blog from "../../components/Blog/Blog";
import Food from "../../components/Food/Food";
import Foods from "../../components/Foods/Foods";
import Login from "../../components/Login/Login";
import MyReviews from "../../components/MyReviews/MyReviews";
import Page404 from "../../components/Page404/Page404";
import PostReview from "../../components/PostReview/PostReview";
import Registration from "../../components/Registration/Registration";
import PrivateRoute from "../Private/PrivateRoute";

const { createBrowserRouter } = require("react-router-dom");
const { default: Home } = require("../../components/Home/Home");
const { default: Main } = require("../../components/Main/Main");

const route = createBrowserRouter([
    {
        path: "/",
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path:'/foods',
                element: <Foods></Foods>
            },
            {
                path: '/food/:id',
                loader: async ({ params }) => fetch(`https://salma-kitchen-server.vercel.app/food/${params.id}`),
                element: <Food></Food>
            },
            {
                path: '/registration',
                element: <Registration></Registration>
            },
            {
                path: '/login',
                element: <Login></Login>
            },
            {
                path: '/post/review/:foodId',
                loader: async ({ params }) => fetch(`https://salma-kitchen-server.vercel.app/food/${params.foodId}`),
                element: <PrivateRoute><PostReview></PostReview></PrivateRoute>
            },
            {
                path: '/my-reviews',
                element: <PrivateRoute><MyReviews></MyReviews></PrivateRoute>
            },
            {
                path: '/add-service',
                element: <PrivateRoute><AddService></AddService></PrivateRoute>
            },
            {
                path: '/blog',
                element: <Blog></Blog>
            },
            {
                path: '*',
                element: <Page404></Page404>
            }
        ]
    }
])
export default route; 